import Language from "../../utils/language";

const state = {
    profile: []
}
const mutations = {
    profile(state, profile) {
        state.profile = profile;
    }

}
const actions = {
    getProfile({
        commit
    }, App) {
        App.Vue.$http.post(App.url, App.data)
            .then(
                response => {
                    if (response.body.resultado !== "NO") {
                        commit('profile', response.body)
                        console.log(response.body);
                    } else {
                        var profile= [];
                        profile[0]={
                            language:response.body.language
                        }
                        commit('profile', profile);
                        //    this.noData = true;
                    }
                },
                () => {
                    commit('profile', []);
                }
            );

    },

}
const getters = {
    profile: state => {
        return state.profile
    },
    language: state => {
        if(state.profile[0] != undefined){
            if(state.profile[0].language != undefined){
                if(state.profile[0].language == "en"){
                    return  Language["en"]
                }
            }
        }

        return Language["es"]
    },
    currebtLanguage: state => {
if(state.profile[0] != undefined){
        if(state.profile[0].language != undefined){
            if(state.profile[0].language == "en"){
                return  "en"
            }
        }
        }
        return "es"
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}